import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  Typography,
  LabelValueColumn,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import { Grid } from '@mui/material';

export interface ReportCreateNewLabelFieldProps {
  label: string;
  component: React.JSX.Element;
  required?: boolean;
  marginBottom?: string;
  width?: string;
  marginRight?: string;
  topRightItem?: React.JSX.Element;
}

const ReportCreateNewLabelField: React.FC<ReportCreateNewLabelFieldProps> = ({
  label,
  component,
  required,
  marginBottom,
  width,
  marginRight,
  topRightItem,
}) => {
  return (
    <LabelValueColumn
      label={
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            fontSize="11px"
            lineHeight="22px"
            textColor={patientAccessTheme.palette.text.highemphasis}
          >
            {label}
            {required ? '*' : ''}
          </Typography>
          {topRightItem && topRightItem}
        </Grid>
      }
      value={component}
      rootStyleProps={{
        width: width ?? 'fit-content',
        marginBottom: marginBottom ?? '16px',
        marginRight: marginRight,
      }}
      labelStyleProps={{
        marginBottom: '3px',
      }}
    />
  );
};

export default ReportCreateNewLabelField;
